import { Avatar, Box, Button, Divider, Typography } from "@mui/material";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import React from "react";
import { Link, useHistory } from "react-router-dom";

export const MenuNameList = ({
  menus = [],
}: {
  menus: MenuForListType[] | undefined;
}) => {
  const history = useHistory();

  const goToOrders = (menu: MenuForListType) => {
    history.push({
      pathname: `/dashboard/menu/${menu.id}/orders`,
      state: menu,
    });
  };

  return (
    <Box>
      {menus.map((menu: MenuForListType, index: number) => (
        <React.Fragment key={index}>
          {index > 0 && <Divider />}
          <Box
            display="flex"
            alignItems="center"
            px={2}
            py={1.5}
            sx={{
              cursor: "pointer",
              "&:hover": { bgcolor: "rgba(0,0,0,0.02)" },
              transition: "background-color 0.15s",
            }}
            onClick={() => goToOrders(menu)}
          >
            <Avatar
              sx={{
                bgcolor: "primary.main",
                width: 36,
                height: 36,
                mr: 2,
                flexShrink: 0,
              }}
            >
              <RestaurantMenuIcon sx={{ fontSize: 20 }} />
            </Avatar>

            <Typography variant="body1" fontWeight={600} flex={1} noWrap>
              {menu.restaurantName}
            </Typography>

            <Button
              size="small"
              component={Link}
              to={`/dashboard/menu/${menu.id}/update`}
              onClick={(e: React.MouseEvent) => e.stopPropagation()}
              sx={{ mr: 1, flexShrink: 0 }}
            >
              Edit menu
            </Button>

            <Button
              size="small"
              variant="contained"
              disableElevation
              endIcon={<ChevronRightIcon />}
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                goToOrders(menu);
              }}
              sx={{ flexShrink: 0 }}
            >
              View orders
            </Button>
          </Box>
        </React.Fragment>
      ))}
    </Box>
  );
};

export type MenuForListType = { id: number; restaurantName: string };
